import store from '../../../store';

const sceneEffectList = [
  { text: '无动画', type: 'None', selected: false },
  { text: '放大', type: 'ZoomIn', selected: false, asset: 'Zoom In' },
  { text: '缩小', type: 'ZoomOut', selected: false, asset: 'Zoom Out' },
  { text: '淡入淡出', type: 'Fade', selected: false, asset: 'Fade' },

  // 注意: RightIn 指的是终点是 right
  { text: '从左移入', type: 'RightIn', selected: false, asset: 'Slide Right' },
  { text: '从右移入', type: 'LeftIn', selected: false, asset: 'Slide Left' },
  { text: '从上移入', type: 'DownIn', selected: false, asset: 'Slide Down' },
  { text: '从下移入', type: 'UpIn', selected: false, asset: 'Slide Up' },
  //
  { text: '手势下移', type: 'Hands', selected: false, asset: 'Hands' },
  { text: '白色涂抹', type: 'WhiteColorSmear', selected: false, asset: 'White Color Smear' },
  { text: '电影打板', type: 'Clipboard', selected: false, asset: 'Clipboard', needVIP: true },
  { text: '电视雪花', type: 'TvNoise', selected: false, asset: 'TV Noise', needVIP: true },
  { text: '帘子下移', type: 'PullDown', selected: false, asset: 'Pull Down', needVIP: true },
  { text: '滚筒刷', type: 'Roller', selected: false, asset: 'Roller', needVIP: true },
  { text: '玻璃刮', type: 'Sqweegee', selected: false, asset: 'Sqweegee', needVIP: true },
  { text: '爆出', type: 'Poof', selected: false, asset: 'Poof', needVIP: true },
  { text: '蓝色涂抹', type: 'BlueColorSmear', selected: false, asset: 'Blue Color Smear', needVIP: true },
  //
  { text: '横向划出', type: 'Swipe', selected: false, asset: 'Swipe' },
  { text: '垂直划像', type: 'SliceVertical', selected: false, asset: 'Slice Vertical' },
  { text: '扇叶向上', type: 'FanUp', selected: false, asset: 'Fan Up', needVIP: true },
  { text: '扇叶向下', type: 'FanDown', selected: false, asset: 'Fan Down', needVIP: true },
  { text: '蓝色螺旋', type: 'SpiralzTech', selected: false, asset: 'Spiralz Tech', needVIP: true },
  { text: '灰色螺旋', type: 'Spiralz', selected: false, asset: 'Spiralz', needVIP: true },
  { text: '水平划像', type: 'SliceHorizontal', selected: false, asset: 'Slice Horizontal', needVIP: true },
  { text: '中间划像', type: 'SliceCenter', selected: false, asset: 'Slice Center', needVIP: true },
  { text: '对角划像', type: 'Slice', selected: false, asset: 'Slice', needVIP: true },
  { text: '翻书', type: 'FlipBook', selected: false, asset: 'FlipBook', needVIP: true },
  { text: '行铺', type: 'RowSpread', selected: false, asset: 'RowSpread', needVIP: true },
  { text: '像素溶解', type: 'Mosaic', selected: false, asset: 'Mosaic', needVIP: true },
  //
  { text: '镜头上移', type: 'CameraUp', selected: false, asset: 'Camera Up' },
  { text: '镜头下移', type: 'CameraDown', selected: false, asset: 'Camera Down', needVIP: true },
  { text: '镜头左移', type: 'CameraLeft', selected: false, asset: 'Camera Left', needVIP: true },
  { text: '镜头右移', type: 'CameraRight', selected: false, asset: 'Camera Right', needVIP: true }
];

export function isNeedVIP (type) {
  const list = sceneEffectList;
  for (let i = 0; i < list.length; i++) {
    const v = list[i];
    if (v.type === type && v.needVIP) {
      return true;
    }
  }
  return false;
}

export function getVipList (scenes) {
  const user = store.getters.UserMsg;
  const list = [];
  const isBasic = user.level === 0 && user.levelType === 0;
  if (!isBasic) {
    return list;
  }
  (scenes || []).map(v => {
    const scenesId = v.id;
    let effectName = v.effect.code;
    let manual = v.effect.manual;
    if (v.fromJsonLoadingState < 2 && effectName === 'None') {
      effectName = v.unLoadData.json ? v.unLoadData.json.exitEffect.type : 'None';
    }
    if (v.fromJsonLoadingState < 2 && !manual) {
      manual = v.unLoadData.json ? v.unLoadData.json.exitEffect.manual : void 0;
    }
    const need = manual && isNeedVIP(effectName);
    const sceneEffectInfo = sceneEffectList.find(item => item.type === effectName);
    need && list.push({
      type: 'sceneEffect',
      scenesId,
      effectType: effectName,
      title: sceneEffectInfo.text,
      payType: 4
    });
  });
  return list;
}



// WEBPACK FOOTER //
// ./src/components/topnav/riskDrop/sceneEffectTypes.js